module.exports = __webpack_public_path__ + "static/media/printer.59b78851.svg";